module.exports = __webpack_public_path__ + "static/media/Dysrhythmia_Question6.f340cfa9.jpg";